const delay = (milliseconds: number) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds))

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function load(parameter: string) {
  await delay(2000)
  return "OK, You got it"
}
